import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const Num = ({ label, value, onChange, testid }) => (
  <label className="block min-w-0">
    <span className="text-[11px] text-slate-500 truncate block">{label}</span>
    <input type="number" data-testid={testid} value={value} onChange={(e) => onChange(Number(e.target.value))} className="mt-1 w-full rounded-md bg-[#070912] border border-white/10 px-3 py-2 text-sm font-mono outline-none focus:border-[#2f7bff]" />
  </label>
);

export const AnalyzePanel = ({ video, onStarted }) => {
  const { t, lang } = useI18n();
  const [o, setO] = useState({ focus: "", max_clips: 15, min_len: 6, max_len: 45 });
  const [busy, setBusy] = useState(false);
  const analyzing = video.status === "analyzing";

  const start = async () => {
    setBusy(true);
    try {
      await api.post(`/videos/${video.id}/analyze`, { ...o, game: video.game || null, lang });
      toast.success(t("an.started"));
      onStarted();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="cx-card rounded-xl p-5" data-testid="analyze-panel">
      <div className="cx-label flex items-center gap-2" style={{ color: "#c79bff" }}><Sparkles className="w-3.5 h-3.5" /> {t("an.title")}</div>
      <input data-testid="analyze-focus-input" value={o.focus} onChange={(e) => setO({ ...o, focus: e.target.value })} placeholder={t("an.focus")} className="mt-4 w-full rounded-md bg-[#070912] border border-white/10 px-3 py-2.5 text-sm outline-none focus:border-[#2f7bff]" />
      <div className="grid grid-cols-3 gap-3 mt-3">
        <Num label={t("an.count")} value={o.max_clips} onChange={(v) => setO({ ...o, max_clips: v })} testid="analyze-max-clips-input" />
        <Num label={t("an.min")} value={o.min_len} onChange={(v) => setO({ ...o, min_len: v })} testid="analyze-min-len-input" />
        <Num label={t("an.max")} value={o.max_len} onChange={(v) => setO({ ...o, max_len: v })} testid="analyze-max-len-input" />
      </div>
      <button data-testid="analyze-start-btn" disabled={busy || analyzing} onClick={start} className={`cx-btn w-full mt-4 rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2 ${analyzing ? "cx-scanbar" : ""}`}>
        {busy || analyzing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
        {analyzing ? t("an.running") : video.highlights.length ? t("an.rerun") : t("an.run")}
      </button>
      {video.summary && <p className="text-xs text-slate-400 mt-4 leading-relaxed" data-testid="video-ai-summary">{video.summary}</p>}
      {video.error && <p className="text-xs text-rose-400 mt-3" data-testid="video-error">{video.error}</p>}
    </div>
  );
};
